export default __webpack_public_path__ + "static/media/ET.c5b365ed.svg";